import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-logo-bar',
  templateUrl: './header-logo-bar.component.html',
  styleUrls: ['./header-logo-bar.component.scss']
})
export class HeaderLogoBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
